import React from 'react'
import { Button, Typography } from '@telavita-core/react-design-kit'

import { NotificationTypeEnum } from 'services/me/preferences'

import { SelectNotificationTypeBannerStateProps } from './types'

import * as S from './styles'

export const SelectNotificationTypeBannerState: React.FC<SelectNotificationTypeBannerStateProps> = ({ handleSelectOption }) => (
  <S.Content>
    <Typography variant='content1' weight='bold'>
      Novidade
    </Typography>

    <S.ContentMessage>
      <Typography variant="content2">
        Agora você pode escolher receber o <strong>lembrete da próxima consulta por WhatsApp</strong>, o jeito mais eficaz pra você não se esquecer da sua sessão!
      </Typography>
    </S.ContentMessage>

    <S.ButtonWrapper>
      <Button
        uppercase={false}
        onClick={() => handleSelectOption(NotificationTypeEnum.SMS)}
        variant="text"
      >
        Manter por SMS
      </Button>
      <Button
        uppercase={false}
        variant="contained"
        onClick={() => handleSelectOption(NotificationTypeEnum.WHATSAPP)}
      >
        Mudar para WhatsApp
      </Button>
    </S.ButtonWrapper>
  </S.Content>
)